// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qd-6";
export var imgContainer = "_qd-3";
export var menuIcon = "_qd-5";
export var pillWrapper = "_qd-2";
export var pillsContainer = "_qd-1";
export var subscriptionCard = "_qd-0";
export var subscriptionLogo = "_qd-4";